import { SHOW_MAIN_NAVBAR, SHOW_SIDE_BAR, HIDE_SIDE_BAR, SHOW_MESSAGE_MODAL, HIDE_MESSAGE_MODAL, SHOW_UTIL_MODAL, HIDE_UTIL_MODAL, SHOW_CONTACT_INFO, HIDE_CONTACT_INFO, SHOW_PRODUCT_MODAL, HIDE_PRODUCT_MODAL, SHOW_ORDER_MODAL, HIDE_ORDER_MODAL, SHOW_PAKKET_MODAL, HIDE_PAKKET_MODAL, SHOW_CHILD_SIDE_BAR, HIDE_CHILD_SIDE_BAR } from './actionTypes'

import { notification } from 'antd';
import { firebaseAuth } from '../../utils/firebase';

import { addPakketProducts } from './productActions';

export const toggleNav = (bool) => ({
  type: SHOW_MAIN_NAVBAR,
  payload: bool
})

export const showSideBar =(sidebar, placement)=>({
  type: SHOW_SIDE_BAR,
  payload: {sidebar, placement}
})

export const hideSideBar =()=>({
  type: HIDE_SIDE_BAR
})


export const showChildSideBar =(sidebar)=>({
  type: SHOW_CHILD_SIDE_BAR,
  payload: sidebar
})

export const hideChildSideBar =()=>({
  type: HIDE_CHILD_SIDE_BAR
})


export const showMessageModal =(msg)=>({
  type: SHOW_MESSAGE_MODAL,
  payload: msg
})

export const hideMessageModel=()=>({
  type: HIDE_MESSAGE_MODAL
})

export const showUtilModal=(comp)=>({
  type: SHOW_UTIL_MODAL,
  payload: comp
})

export const hideUtilModal=()=>({
  type: HIDE_UTIL_MODAL
})

export const showNotifaction = (type, title, msg, btn)=> dispatch =>{
  notification.config({
    duration: 2
  })
  notification[type]({
    message: title,
    description:msg,
    btn,
    className: 'notifaction-card',
    key: title,
    onClick(){
      notification.close(title)
      dispatch(showSideBar('cart'))
    }   
  });
}

export const showContactInfo = () => ({
  type: SHOW_CONTACT_INFO
})

export const hideContactInfo = () => ({
  type: HIDE_CONTACT_INFO
})

export const showProductModal = (product) => ({
  type: SHOW_PRODUCT_MODAL,
  payload: product
})

export const hideProductModal = () => ({
  type: HIDE_PRODUCT_MODAL
})

export const showPakketModal = (pakket)=> dispatch => {
  dispatch({
    type: SHOW_PAKKET_MODAL,
    payload: pakket
  })
  dispatch(addPakketProducts(pakket.producten))
}

export const hidePakketModal = () => dispatch => {
  dispatch({
    type: HIDE_PAKKET_MODAL
  })
  dispatch(addPakketProducts([]))
}

export const showOrderModal = (order) => ({
  type: SHOW_ORDER_MODAL,
  payload: order
})

export const hideOrderModal = () => ({
  type: HIDE_ORDER_MODAL
})

export const whoIs =()=>{
  var user = firebaseAuth.currentUser;
  console.log(user)
}